import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, reactive, defineAsyncComponent } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'simpleEditor',
  setup(__props) {

let Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const state = reactive({
    content: '<h1>Some initial content</h1>',
    _content: '',
    editorOption: {
        placeholder: 'core',
    },
    disabled: false
})
const onEditorChange = (html: string) => {

    state._content = html
}
setTimeout(() => {
    state.disabled = true
}, 2000)

return (_ctx: any,_cache: any) => {
  const _component_quill_editor = _resolveComponent("quill-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card3), {
        colClass: "col-sm-12",
        title: "Simple Editor",
        headerTitle: "true"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_quill_editor, {
            value: state.content,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.content) = $event)),
            options: state.editorOption,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (onEditorChange($event)))
          }, null, 8, ["value", "options"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})